import React, { Component } from "react";
import {

    View, Text,
    Platform,
    StyleSheet,
    ActivityIndicator, TouchableOpacity
} from "react-native";
import { moderateScale } from "../tools/Scaling";
import Colors,{ colorPrimary } from "../tools/Colors";
import HMTextView from "../customviews/HMTextView";
import i18n from "../I18n/i18n";

export default  class DialogLoadingCustomize extends Component {
    constructor(props) {
        super(props);

    }
    render() {
          const {selfStyle,text , onPress,numberOfLines,small} =this.props;
        return (
            <View style={styles.modalBackDrop}>
                {
                    small ?
                        <View style={{backgroundColor:"white",flexDirection:'row',width:moderateScale(50),height:moderateScale(50),borderRadius: moderateScale(25),justifyContent:'center',alignItems:'center'}}>

                            <ActivityIndicator color={Colors.colorPrimary} size={"large"}/>

                        </View>
                        :
                        <View style={{backgroundColor:"white",flexDirection:'row',width:"80%",height:moderateScale(90),borderRadius: moderateScale(8),justifyContent:'center',alignItems:'center'}}>

                            <ActivityIndicator color={Colors.colorPrimary} size={"large"}/>
                            <HMTextView
                                text={text ?text :i18n.t('constant.Wait')}
                                type={'bold'}
                                style={{
                                    alignSelf: 'center',
                                    //  marginRight: moderateScale(6),
                                    marginHorizontal: moderateScale(10),
                                    textAlign: 'center',
                                    color: Colors.colorDarkText,
                                    fontSize: moderateScale(14),
                                }}/>
                        </View>
                }

            </View>
        );
    }
}
const styles = StyleSheet.create({
    modalBackDrop: {
        position: 'absolute',
       // height: typeExport._HEIGHT,
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',

        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        backgroundColor: 'rgba(0,0,0,0.7)',
        zIndex: 9900
    },
    modalDialog: {
        flexDirection: 'column',
        borderWidth: 1,
        ...Platform.select({
            ios: {
                shadowColor: '#000',
                shadowOffset: { width: 0, height: 2 },
                shadowOpacity: 0.1,
            },
            android: {
                elevation: 1

            },
          }),
        width: '70%',
        minHeight: 150,
        margin: 'auto',
        backgroundColor: 'white',
        borderRadius: 10,
        justifyContent: 'center',
        alignItems: 'center',
    },
    modalLoading: {
        textAlign: "center",
    },
    modalText: {
        fontSize: moderateScale(16),
        color: 'black'
    }
});

  /*

        alignItems: 'flex-start',
        alignItems: 'flex-end',

  */
